import { PropsWithChildren } from 'preact/compat';
import { AnalyticsProvider } from 'zl-shared/dist/video-analytics';

const VideoAnalyticsProvider = ({ children }: PropsWithChildren) => {
  return <AnalyticsProvider defaultTimeInterval={15000}>{children}</AnalyticsProvider>;
};

export default VideoAnalyticsProvider;
